import { FormsTabs } from './FormsTabs';

export type { TypeFormsTabsProps } from './types';
export default FormsTabs;
